import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const recommendedAccountTypesReducer = (state = {private: "Privatkunde", business: "Geschäftskunde"}, action) => {

    switch (action.type) {

        case ActionTypes.CUSTOMER_CATEGORIES_SUCCESS:

            const keyValueTypes = {}

            Object.entries(action.response.entities.customerCategory).forEach(([key, value]) => {
                keyValueTypes[key] = value.name
            })
            return keyValueTypes

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/RecAccountTypes.js
 **/